import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthRoutes, UserRoute } from '@core/constants/routes.const';
import { environment } from '@env';

@Component({
  selector: 'app-login.main',
  templateUrl: './login.main.component.html',
  styleUrls: ['./login.main.component.scss'],
})
export class LoginMainComponent implements OnInit {
  readonly iframeMinHeight = '20rem';
  readonly LoginViaEmail = AuthRoutes.Login;
  readonly LoginViaPhone = AuthRoutes.LoginViaPhone;
  readonly RegistrationRoute = UserRoute.Registration;

  readonly mobileLogin = environment.feature.mobileLogin;

  prefillEmail: string;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
  }
}
